import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { BlogTags } from '@app/_shared/_enums/blog-tags';
import { SEO, IShopifyProduct } from '@app/_shared/_models';
import { BlogService, SeoService } from '@app/_shared/_services';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IBlogPost } from '../_prismic/blog-post';
import { ImageComponent } from '../../_shared/_components/image/image.component';
import { AsyncPipe, UpperCasePipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-get-your-hot-tub-ready-for-winter',
    templateUrl: './get-your-hot-tub-ready-for-winter.component.html',
    styleUrls: ['./get-your-hot-tub-ready-for-winter.component.scss'],
    imports: [NgxSpinnerComponent, ImageComponent, RouterLink, AsyncPipe, UpperCasePipe, DatePipe]
})
export class GetYourHotTubReadyForWinterComponent implements OnInit, OnDestroy {
  private readonly blogService = inject(BlogService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);
  private readonly seoService = inject(SeoService);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/hot-tub-in-winter-mountains.webp',
    metaDescription: `Prepare your hot tub for colder months with our guide on chemical treatments, pH balancing, and maintenance. Ensure clean, safe water for cozy soaks.`,
    metaTitle: `Essential Hot Tub Chemical Care Tips for Fall & Winter`
  };
  public spinner$: Observable<NgxSpinner>;
  public blogPost!: IBlogPost;
  public ahhSome: IShopifyProduct | undefined;
  private readonly blogTags = BlogTags;
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    const ngxSpinnerService = this.ngxSpinnerService;

    this.spinner$ = ngxSpinnerService.spinnerObservable;
  }

  public async ngOnInit(): Promise<void> {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/blog/get-your-hot-tub-ready-for-winter');

    await this.ngxSpinnerService.show();
    this.blogService.blogs$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async (blogs: Array<IBlogPost>) => {
        const index = blogs.findIndex(b => b.tag === this.blogTags.GET_HOT_TUB_READY_FOR_SEASON);
        if (index > -1) {
          this.blogPost = blogs[index];
          await this.ngxSpinnerService.hide();
        } else {
          await this.blogService.loadBlogs();
        }
      });
  }

  public ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
